/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'overview',
        title: 'Overview',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/overview'
    },
    {
        id   : 'home',
        title: 'Home',
        type : 'basic',
        icon : 'heroicons_outline:home',
        link : '/home'
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'overview',
        title: 'Overview',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/overview'
    },
    {
        id   : 'home',
        title: 'Home',
        type : 'basic',
        icon : 'heroicons_outline:home',
        link : '/home'
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'overview',
        title: 'Overview',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/overview'
    },
    {
        id   : 'home',
        title: 'Home',
        type : 'basic',
        icon : 'heroicons_outline:home',
        link : '/home'
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'overview',
        title: 'Overview',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/overview'
    },
    {
        id   : 'home',
        title: 'Home',
        type : 'basic',
        icon : 'heroicons_outline:home',
        link : '/home'
    },
];
